export default __webpack_public_path__ + "static/media/480_dummy2016-fotograf04-mobile-de.550ba4e6.png";